import { render, staticRenderFns } from "./approval-dashboard.vue?vue&type=template&id=10b9dc00&scoped=true"
import script from "./approval-dashboard.vue?vue&type=script&lang=js"
export * from "./approval-dashboard.vue?vue&type=script&lang=js"
import style0 from "./approval-dashboard.vue?vue&type=style&index=0&id=10b9dc00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9dc00",
  null
  
)

export default component.exports